import { Box, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import FullScreenLoader from '@/components/FullScreenLoader';

interface Props {
    id?: string;
    loading?: boolean;
    children: ReactNode;
}

export default function ClientViewWrapper({ id, loading = false, children }: Props) {
    const theme = useTheme();

    return (
        <Box
            id={id}
            sx={{
                minHeight: '100vh',
                width: '100vw',
                backgroundColor: theme.palette.neutral.darkBlue,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {children}
            {loading && <FullScreenLoader />}
        </Box>
    );
}
